export default [
  {
    header: 'breadcrumb.configuration',
    resource: 'configuration-header',
  },
  {
    title: 'breadcrumb.setting',
    icon: 'SettingsIcon',
    children: [
      {
        title: 'breadcrumb.chatSettings',
        route: 'chat-settings',
        icon: '',
        resource: 'chat-settings',
        action: 'read',
      },
      {
        title: 'breadcrumb.call-center',
        route: 'call-center',
        icon: '',
        resource: 'call-center',
        action: 'read',
      },
      {
        title: 'breadcrumb.serviceSystemSetting',
        route: 'system-service-setting',
        icon: '',
        resource: 'service-setting',
        action: 'read',
      },
      {
        title: 'breadcrumb.integration',
        route: 'integration',
        icon: '',
        resource: 'merchant-integration',
        action: 'read',
      },
      // {
      //   title: "breadcrumb.general",
      //   route: "general",
      //   icon: "",
      //   resource: "general-settings",
      //   action: "read",
      // },
      // {
      //   title: 'breadcrumb.chatWidget',
      //   route: 'chat-widget',
      //   icon: '',
      //   resource: 'customize-chat-widget',
      //   action: 'read',
      // },

      // {
      //   title: "breadcrumb.chatPartner",
      //   route: "private-chat-integration",
      //   icon: "",
      //   resource: "private-chat-integration",
      //   action: "read",
      // },
      {
        title: 'breadcrumb.businessInformation',
        route: 'business-information',
        icon: '',
        resource: 'modify-business-info',
        action: 'read',
      },
      {
        title: 'breadcrumb.whitelistIP',
        route: 'whitelist-ip',
        icon: '',
        resource: 'manage-whitelist-ips',
        action: 'manage',
      },
      // {
      //   title: "breadcrumb.quickMessage",
      //   route: "quick-message",
      //   icon: "",
      //   resource: "modify-business-info",
      //   action: "read",
      // },
      // {
      //   title: "breadcrumb.chatPage",
      //   route: "chat-page",
      //   icon: "",
      //   resource: "chat-page",
      //   action: "read",
      // },
      // {
      //   title: "breadcrumb.bot",
      //   route: "bot",
      //   icon: "",
      //   resource: "bot",
      //   action: "read",
      // },
      // {
      //   title: "breadcrumb.voiceAlertSettings",
      //   route: "voice-alert-settings",
      //   icon: "",
      //   resource: "voice-settings",
      //   action: "read",
      // },
      // {
      //   title: "title.chatAgent",
      //   route: "chat-agent",
      //   icon: "",
      //   resource: "chat-agent",
      //   action: "read",
      // },
    ],
  },
]
